// Port of api/fuel/app/classes/filter/search/games/filters/query/advanced.php
import F from 'offline/filter/constants'
import Evaluate from 'offline/filter/advanced/evaluate'
import DB from 'offline/db'
import Util from 'offline/util'

export default {
	name: 'advanced',
	priority: 2,
	require: function(config, filter) {
		var advanced = filter && filter.advanced
		if (Array.isArray(advanced)) return advanced.length > 0
		return !!(advanced && Array.isArray(advanced.rules) && advanced.rules.length)
	},
	run: function(config, filter, data, query) {

		var processor = function(rules, seedIndex) {
			// Run a sub-filter with these rules in advanced mode
			var subConfig = {}
			var keys = Object.keys(config)
			for (var i = 0; i < keys.length; i++) subConfig[keys[i]] = config[keys[i]]

			subConfig.filterMode = F.MODE_ADVANCED
			subConfig.asIndex = true
			subConfig.seedIndex = seedIndex
			subConfig.filter = { rules: rules }

			var FilterClass
			if (config.resultType === F.RESULT_COLLECTION) {
				FilterClass = require('offline/filter/collection').default
			} else if (config.resultType === F.RESULT_RATING) {
				FilterClass = require('offline/filter/ratings').default
			} else if (config.resultType === F.RESULT_PLAY) {
				FilterClass = require('offline/filter/plays').default
			} else if (config.resultType === F.RESULT_GAME) {
				FilterClass = require('offline/filter/games').default
			}

			if (FilterClass && FilterClass.forge) {
				return FilterClass.forge(subConfig).run()
			}

			return []
		}

		var universalIndex = function() {
			var rows
			if (config.resultType === F.RESULT_COLLECTION) {
				rows = DB.query('SELECT collection_id FROM collection WHERE user_id IN(' + Util.in(config.users) + ')')
				return Util.pluck(rows, 'collection_id')
			} else if (config.resultType === F.RESULT_RATING) {
				rows = DB.query('SELECT rating_id FROM rating WHERE user_id IN(' + Util.in(config.users) + ')')
				return Util.pluck(rows, 'rating_id')
			} else if (config.resultType === F.RESULT_PLAY) {
				rows = DB.query('SELECT play_id FROM play WHERE user_id IN(' + Util.in(config.users) + ')')
				return Util.pluck(rows, 'play_id')
			} else if (config.resultType === F.RESULT_GAME) {
				rows = DB.query('SELECT game_id FROM game')
				return Util.pluck(rows, 'game_id')
			}
			return []
		}

		var resultIndex = Evaluate.run(filter.advanced, processor, universalIndex)

		if (!resultIndex.length) resultIndex.push(0)

		var field
		if (config.resultType === F.RESULT_COLLECTION) field = 'c.collection_id'
		else if (config.resultType === F.RESULT_RATING) field = 'r.rating_id'
		else if (config.resultType === F.RESULT_PLAY) field = 'p.play_id'
		else if (config.resultType === F.RESULT_GAME) field = 'g.game_id'

		query.where(field, 'in', resultIndex)
	}
}
